import { fromUnixTime } from 'date-fns';
import { IEnrichedFlight } from '../features/flights/shared/flight/domain/models/IEnrichedFlight';
import { convertDateToTimeZone } from './convertDateToTimeZone';

export function getFlightDateTime(flight: IEnrichedFlight) {
	return convertDateToTimeZone(fromUnixTime(flight.bestKnownTimestamp));
}
